import React, { useMemo } from "react";
import { useRecoilValue } from "recoil";

import useClickToCall from "../useClickToCall";
import { getDerivedState, getPhoneImageUrl, getPhoneImageClassName } from "../utils";
import { ACTIVE_STATE_TYPES, clickToCallAtom } from "../constants";

import styles from "./callMinimizedView.scss";

export default function CallMinimizedView() {
  const state = useRecoilValue(clickToCallAtom);
  const { dismiss, maximize } = useClickToCall();

  const handleDismiss = (e) => {
    e.stopPropagation();
    dismiss();
  }

  const { message, agentStatus, userStatus, duration, isActionButtonsShown } = getDerivedState(state);

  const phoneImageUrl = useMemo(() => getPhoneImageUrl(agentStatus, userStatus, ACTIVE_STATE_TYPES.CALL_MINIMIZED), [agentStatus, userStatus]);
  const phoneImageClassName = useMemo(() => getPhoneImageClassName(agentStatus, userStatus), [agentStatus, userStatus]);

  return (
    <div onClick={maximize} className={styles.call_minimized_view}>
      <div className={styles.notify_content}>
        <span className={`${styles.phone_icon} ${styles[phoneImageClassName]}`}>
            <img src={phoneImageUrl}  />
        </span>
        <span className={styles.caller_text}>
          {message}
          {" "}
          {duration}
          {isActionButtonsShown && <span onClick={handleDismiss} className={styles.dismiss}>Dismiss</span>}
        </span>
      </div>
    </div>
  );
}
